<template>
  <div class="card">
    <h5 class="card-header bg-primary text-white">Details</h5>
    <div class="card-body">
      <form>
        <div class="form-row">
          <div class="col-12 col-md-6">
            <div class="form-group row">
              <label class="col-5 col-lg-4 col-form-label">Investigation Id</label>
              <input
                type="text"
                class="col-7 col-lg-8 form-control-plaintext"
                readonly
                placeholder="---"
                :disabled="isLoading"
                v-model="investigation.referenceCode"
              />
            </div>
            <div class="form-group row">
              <label class="col-5 col-lg-4 col-form-label">Created By</label>
              <input
                type="text"
                class="col-7 col-lg-8 form-control-plaintext"
                readonly
                placeholder="---"
                :disabled="isLoading"
                v-model="investigation.createdByUserFullName"
              />
            </div>
            <div class="form-group row">
              <label class="col-5 col-lg-4 col-form-label">Created On</label>
              <input type="text" class="col-7 col-lg-8 form-control-plaintext" readonly placeholder="---" :disabled="isLoading" v-model="createdDate" />
            </div>
            <div class="form-group row">
              <label class="col-5 col-lg-4 col-form-label">Case Type</label>
              <input
                type="text"
                class="col-7 col-lg-8 form-control-plaintext"
                readonly
                placeholder="---"
                :disabled="isLoading"
                v-model="investigation.caseTypeCategoryDisplayName"
              />
            </div>
          </div>

          <div class="col-12 col-md-6">
            <div class="form-group row">
              <label class="col-5 col-lg-4 col-form-label">Closed On</label>
              <input type="text" class="col-7 col-lg-8 form-control-plaintext" readonly placeholder="---" :disabled="isLoading" v-model="closeDate" />
            </div>
            <div class="form-group row">
              <label class="col-5 col-lg-4 col-form-label">Outcome</label>
              <input
                type="text"
                class="col-7 col-lg-8 form-control-plaintext"
                readonly
                placeholder="---"
                :disabled="isLoading"
                v-model="investigation.outcomeShortDescription"
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import formatter from "@/utils/formatter";

export default {
  props: {
    isLoading: Boolean,
    investigation: Object,
  },
  computed: {
    formatter: () => formatter,
    createdDate() {
      if (!this.investigation.createdDate) return null;
      return formatter.date.default(this.investigation.createdDate);
    },
    closeDate() {
      if (!this.investigation.closeDate) return null;
      var utcDate = moment.utc(this.investigation.closeDate); // handle utc round-trip from server
      return formatter.date.default(utcDate);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/base.scss";

.form-group {
  margin-bottom: 0;
}

input[readonly="readonly"] {
  outline: 0px transparent;
}

textarea[readonly="readonly"] {
  outline: 0px transparent;
}
</style>
